// Rahmenwerk (Referenz-Tabelle Raumtyp -> Standard-Funktionen), vom Nutzer als CSV
// bereitgestellt. Wird Claude als Referenz mitgegeben, damit es die Ausstattungs-Vorschläge
// (siehe equipmentSuggestion.ts) konsistent zur tatsächlichen Planungspraxis macht, statt
// eine lokale Keyword-Heuristik zu verwenden. Encoding der Originaldatei (UTF-8 als
// Latin-1 gelesen) hier korrigiert.
export const ROOM_FUNCTION_FRAMEWORK = `Raum,Funktion/Gerät,Name
"Badezimmer (<4qm)","Leuchte gedimmt","Deckenbeleuchtung"
,"Leuchte geschaltet","Spiegelleuchte"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Sensor","Präsenzmelder"

"Badezimmer (>4qm)","Leuchte gedimmt","Deckenbeleuchtung"
,"Leuchte geschaltet","Spiegelleuchte"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Taster",""

"WC/Gäste WC","Leuchte gedimmt","Deckenbeleuchtung"
,"Leuchte geschaltet","Spiegelleuchte"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Sensor","Präsenzmelder"

"Flur","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"
,"Sensor","Präsenzmelder"

"Treppenhaus","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung Flur"
,"Steckdose","Steckdosen"
,"Sensor","Präsenzmelder"

"Gästezimmer","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Taster","Bett"
,"Taster","Eingang"

"Wohnzimmer/Wohnen","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"
,"Taster",""

"Küche","Leuchte gedimmt","Deckenbeleuchtung"
,"Leuchte geschaltet","Arbeitsplatte"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","SD Arbeitsplatte 1"
,"Steckdose","SD Arbeitsplatte 2"
,"Verbraucher 400V","Kochfeld"
,"Steckdose","Backofen"
,"Steckdose","Spülmaschine"
,"Steckdose","Kühlschrank"
,"Steckdose","Microwelle"
,"Steckdose geschaltet","SD geschaltet"
,"Taster",""

"Esszimmer","Leuchte gedimmt","Deckenbeleuchtung"
,"Leuchte gedimmt","Esstischbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"
,"Taster",""

"Schlafzimmer/Eltern","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","Bett rechts"
,"Steckdose geschaltet","Bett links"
,"Taster","Bett rechts"
,"Taster","Bett links"
,"Taster","Eingang"

"Kinderzimmer","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"
,"Taster","Bett"
,"Taster","Eingang"

"Abstellraum/-kammer","Leuchte geschaltet","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Steckdose","Steckdosen"
,"Sensor",""

"Waschküche/HWR","Leuchte geschaltet","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Steckdose","Steckdosen"
,"Steckdose","Waschmaschine"
,"Steckdose","Trockner"
,"Taster",""

"Arbeitszimmer","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","Schreibtisch"
,"Taster",""

"Dachboden","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Taster",""

"Balkon","Leuchte geschaltet","Balkonbeleuchtung"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"

"Terrasse","Leuchte geschaltet","Terrassenbeleuchtung"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"

"Garten","Leuchte geschaltet","Gartenbeleuchtung 1"
,"Leuchte geschaltet","Gartenbeleuchtung 2"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet 1"
,"Steckdose geschaltet","SD geschaltet 2"

"Garage","Leuchte geschaltet","Garagenbeleuchtung"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","SD geschaltet"
,"400V Verbraucher","Wallbox"
,"Kontakt","Garagentor"
,"Sensor","Präsenzmelder"
,"Taster",""

"Wintergarten","Leuchte gedimmt","Deckenbeleuchtung"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Taster",""

"Kellerraum","Leuchte geschaltet","Deckenbeleuchtung"
,"Steckdose","Steckdosen"
,"Taster",""

"Technikraum","230V Verbraucher","konventionelle"

"Ankleide","Leuchte gedimmt","Deckenbeleuchtung"
,"Heizen","Heizung [Raumname]"
,"Rollladen/Jalousie","Beschattung"
,"Kontakt","Fensterflügel"
,"Steckdose","Steckdosen"
,"Steckdose geschaltet","Licht Schrank 1"
,"Steckdose geschaltet","Licht Schrank 2"
,"Taster",""

"Laubengang","Leuchte geschaltet","Beleuchtung"
,"Steckdose","Steckdosen"
,"Sensor","Bewegungsmelder"
`;
